import React, { useState, useEffect } from 'react'
import { Tabs } from 'antd'
import { getMembershipFees } from '../../api/team'
import MemberShip from './membership'
import AppleMembership from './AppleMembership'
// import MembershipV2 from './V2/membership'
import Services from './service'
// import MemberShipV1 from './v1/membership'
// import ServicesV1 from './v1/service'
import PageLoading from '../UI/status/loading'
import { loadUser } from '../../utils/storage'

const { TabPane } = Tabs

function MembershipContainer(props) {
  const [price, setPrice] = useState(null)
  const user = loadUser()
  const company = user && user.profile && user.profile.company
  const isAppleUser = company === 'Apple - Cupertino'

  useEffect(() => {
    const getFees = async () => {
      const result = await getMembershipFees(user.id)
      setPrice(result)
    }
    getFees()
  }, [])

  const appleUserTabs = [
    {
      name: company === 'Apollo - New York'
        ? 'Apollo Memberships'
        : 'Apple Memberships',
      key: company === 'Apollo - New York'
        ? 'Apollo Memberships'
        : 'Apple Memberships',
      pane: (
        <AppleMembership
          price={price}
          current={user.profile.membership}
          selectable={false}
        />
      )
    },
    {
      name: 'Apeiron Memberships',
      key: 'ApeironMembership',
      pane: (
        <MemberShip
          editable={false}
          price={price}
          current={user.profile.membership}
        />
      )
    },
    {
      name: 'Services',
      key: 'Services',
      pane: <Services />
    }
  ]

  const tabs = [
    {
      name: 'MEMBERSHIP',
      key: 'Membership',
      pane: (
        <MemberShip
          editable={false}
          price={price}
          current={user.profile.membership}
        />
      )
    },
    {
      name: 'SERVICES',
      key: 'Services',
      pane: <Services />
    }
  ]

  const tabsToRender = isAppleUser ? appleUserTabs : tabs

  return (
    <div style={{ paddingRight: 4 }}>
      <Tabs defaultActiveKey="Membership">
        {tabsToRender.map((item) => (
          <TabPane
            tab={
              isAppleUser ? (
                <span style={{ fontSize: '20px', fontWeight: 500 }}>{item.name}</span>
              ) : (
                item.name
              )
            }
            key={item.key}
          >
            {price ? item.pane : <PageLoading />}
          </TabPane>
        ))}
      </Tabs>
    </div>
  )
}

export default MembershipContainer
